// extracted by mini-css-extract-plugin
export default {"content":"KF4n2","modal":"sMWOz","button":"UHS90"};